import { Button, ButtonProps } from '@mui/material';
import { useMemo } from 'react';
import { NavLinkProps } from 'react-router-dom';

type NavButtonProps = NavLinkProps & ButtonProps;

/**
 * A button specific for navigation and will show an active state
 */
const NavButton = (props: NavButtonProps) => {
  const combinedProps = useMemo<NavButtonProps>(
    () => ({
      ...props,
      sx: {
        ...props.sx,
        '&.active': {
          border:
            props.variant == 'text' || props.variant == undefined
              ? '1px solid'
              : 'initial',
        },
      },
    }),
    [props]
  );

  return (
    <Button color="secondary" {...combinedProps}>
      {props.children}
    </Button>
  );
};

export default NavButton;
